export default "__VITE_ASSET__a22bd67b__"